import { Component } from "react";
import { graphql } from "gatsby";
import { extract, EventAggregator, JetshopStore, GhostButton } from "@parksandresorts/core";
import styles from "./product-list-block.module.less";
import ProductListItem from "components/block-elements/product-list-item/product-list-item";
import { runKeyDownOnEnter } from "components/helpers/interaction-helper";

const ITEM_TYPES = {
  half: "HALF",
  third: "THIRD",
  center: "CENTER",
};

export default class ProductListBlock extends Component {
  constructor(props) {
    super(props);

    this.productLists = extract(props, "productLists", []);

    this.buttonIcons = {
      icon: "",
      iconToggle: "icon-close",
    };

    this.state = {
      jetshopDataLoaded: false,
      listOpenState: this.createListOpenState(this.productLists),
    };
  }

  createListOpenState(productLists) {
    const listOpenState = {};

    if (!productLists) {
      return {};
    }

    productLists.forEach((productList) => {
      listOpenState[productList.id] = typeof productList.isExpanded === "boolean" ? productList.isExpanded : true;
    });

    return listOpenState;
  }

  componentDidMount() {
    this._isMounted = true;

    JetshopStore.getAllExtendedProducts()
      .then((extendedProducts) => {
        this.productLists.forEach((list) => {
          list.listObjects.forEach((productInList) => {
            const extendedProduct = extendedProducts.find((extendedProduct) =>
              JetshopStore.isEqualProducts(extendedProduct, productInList),
            );
            if (extendedProduct) {
              Object.assign(productInList, extendedProduct);
            }
          });
        });

        if (this._isMounted) {
          this.setState({ jetshopDataLoaded: true });
        }
      })
      .catch((err) => console.error("Failed getting extended products: ", err));
  }

  getTwoThreeGridTypeForIndex(index) {
    const indexWithStartOne = index + 1;
    const belongsToSubGrid = Math.ceil(indexWithStartOne / 5);
    const lastIndexInSubGrid = belongsToSubGrid * 5;
    const indexFromEndInsideSubGrid = lastIndexInSubGrid - indexWithStartOne;

    if (indexFromEndInsideSubGrid <= 2) {
      return ITEM_TYPES.third;
    }

    return ITEM_TYPES.half;
  }

  getTypeOfItemForIndex(numberOfItems, index) {
    if (!numberOfItems) {
      return null;
    }

    if (numberOfItems % 2 === 0 && numberOfItems < 5) {
      return ITEM_TYPES.half;
    }

    if (numberOfItems === 3 || numberOfItems === 6 || numberOfItems === 9) {
      return ITEM_TYPES.third;
    }

    if (numberOfItems === 1) {
      return ITEM_TYPES.center;
    }

    return this.getTwoThreeGridTypeForIndex(index);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClick(list) {
    this.setState({
      listOpenState: {
        ...this.state.listOpenState,
        [list.id]: !this.state.listOpenState[list.id],
      },
    });
    EventAggregator.publish("trackEvent", {
      category: "Product List",
      action: this.state.listOpenState[list.id] ? "Closed" : "Opened",
      label: list.headline && list.headline,
    });
  }

  render() {
    return (
      <section className="block block--max-width" data-contentful-id={this.props.contentful_id}>
        <div className={styles.productListWrapper}>
          {this.productLists.map((list) => {
            const listSize = list.listObjects ? list.listObjects.length : null;

            return (
              <div
                key={list.id}
                className={[styles.listWrapper, this.state.listOpenState[list.id] ? styles.open : styles.closed].join(
                  " ",
                )}
              >
                <div
                  tabIndex={0}
                  role="button"
                  onKeyDown={(e) => runKeyDownOnEnter(e, () => this.handleClick(list))}
                  onClick={() => this.handleClick(list)}
                  className={styles.innerContainer}
                >
                  {list.headline && <h3 className={styles.listHeadline}>{list.headline}</h3>}
                  {this.state.listOpenState[list.id] ? null : (
                    <div className={styles.listItemCounter}>{"(" + list.listObjects.length + ")"}</div>
                  )}
                  <GhostButton
                    className={styles.hideButton}
                    iconRight={this.state.listOpenState[list.id] ? undefined : "icon-add-circle"}
                    label={this.state.listOpenState[list.id] ? "Dölj" : ""}
                  />
                </div>
                <div
                  className={[styles.list, this.state.listOpenState[list.id] ? styles.open : styles.closed].join(" ")}
                >
                  {list.listObjects &&
                    list.listObjects.map((product, index) => {
                      const itemType = this.getTypeOfItemForIndex(listSize, index);
                      return (
                        <ProductListItem
                          disableSoldOut={true}
                          key={product.contentful_id}
                          gridType={itemType}
                          {...product}
                        />
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

export const fragmentProductListBlock = graphql`
  fragment ProductListBlock on ContentfulProductListBlock {
    contentful_id
    id
    filterTags {
      id
      title
    }
    productLists {
      id
      headline
      isExpanded
      listObjects {
        __typename
        ...ProductBlock
      }
    }
  }
`;
